import { KeyboardArrowDown } from "@mui/icons-material";
import { Autocomplete, Paper, TextField } from "@mui/material";
import { useEffect, useState } from "react";

import HNSColors from "../../HNSColors";

import CustomListBoxWithShowMore from "./CustomListBoxWithShowMore";

const StyledPaper = (props) => (
  <Paper
    {...props}
    sx={{
      ...props?.sx,
    }}
  />
);

const AutoCompleteDropdown = ({
  label,
  data = [],
  initValue = null,
  noOptionsText = "No Results",
  onValueChange = () => {},
  onInputChange = () => {},
  freeSolo = false,
  multiple = false,
  nextPageURL = null,
  getOptionLabel = (option) => option?.label || option || "",
  isOptionEqualToValue = (option, value) => option?.id === value?.id || option === value,
  ListboxComponent = CustomListBoxWithShowMore,
  ListboxProps = {},
  filterOptions,
  textFieldSx = {},
  disabled = false,
  getOptionDisabled,
  error = false,
  size = "medium",
  dropdownSx = {},
  popupIcon = <KeyboardArrowDown sx={{ fontSize: 24, color: HNSColors.primary[500] }} />,
  placeholder = "",
  disableClearable = false,
  disablePortal = true,
  renderTags = null,
  helperText = "",
  className = "h-full w-full",
}) => {
  const [selectedValue, setSelectedValue] = useState(initValue ?? (multiple ? [] : null));

  const handleChange = (event, value) => {
    setSelectedValue(value);
    onValueChange(event, value);
  };

  useEffect(() => {
    setSelectedValue(initValue ?? (multiple ? [] : null));
  }, [initValue, multiple]);

  return (
    <Autocomplete
      error={String(error)}
      size={size}
      multiple={multiple}
      disablePortal={disablePortal}
      freeSolo={freeSolo}
      options={data}
      disabled={disabled}
      getOptionLabel={getOptionLabel}
      {...(filterOptions ? { filterOptions } : {})}
      value={selectedValue}
      noOptionsText={noOptionsText}
      isOptionEqualToValue={isOptionEqualToValue}
      className={className}
      renderInput={(params) => (
        <TextField
          error={error}
          {...params}
          label={label}
          sx={textFieldSx}
          placeholder={placeholder}
          helperText={helperText}
        />
      )}
      onChange={handleChange}
      onInputChange={onInputChange}
      ListboxComponent={ListboxComponent}
      ListboxProps={{
        ...ListboxProps,
        nextPageURL,
      }}
      popupIcon={popupIcon}
      PaperComponent={(props) => <StyledPaper {...props} sx={dropdownSx} />}
      disableClearable={disableClearable}
      getOptionDisabled={
        getOptionDisabled ? (option) => getOptionDisabled(option, selectedValue) : undefined
      }
      renderTags={renderTags}
    />
  );
};
export default AutoCompleteDropdown;
